import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { MobileNav } from '@/widgets/mobile-nav';
import { Sidebar } from '@/widgets/sidebar';

import { WelcomeModal } from '@/shared/ui/welcome-modal';
import { setNavigate } from '@/shared/utils/router-navigation';

export const BaseLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the navigate function globally for use outside React components
    setNavigate(navigate);
  }, [navigate]);

  return (
    <div className="h-screen bg-zinc-900 text-white flex overflow-hidden">
      {/* Desktop Sidebar - hidden on mobile */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden">
        <main className="flex-1 overflow-auto bg-zinc-900 pb-16 lg:pb-0">
          <Outlet />
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav />

      {/* Welcome modal for first-time users */}
      <WelcomeModal />
    </div>
  );
};
